import React from 'react';
import './App.css'; // Assuming your CSS file
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Service2 = () => {
    const navigate = useNavigate(); // Initialize navigate

    // Function to handle navigation
    const handleNavigate = () => {
        navigate('/galleries'); // Navigate to the gallery page
    };

    return (
       <div className="about-events-container">

               {/* First section: Images */}
               <div className="about-events-images">
                 <img src="/images/coco6.webp" />
                 <img src="/images/coco3.webp" />
                 <img src="/images/ser3.webp" />
                 <img src="/images/shoot4.webp"/>
               </div>

               {/* Second section: Content */}
               <div className="about-events-content">
                 <h2 className="about-header-service">Wedding Event Celebrations</h2>

                 <p className="about-events-description">
                  <p>At CocoLoco, your dream wedding becomes a reality with our stunning outdoor venue, perfect for creating unforgettable memories. Surrounded by serene poolside and garden views, our location offers the ideal backdrop for your special day, whether it’s an intimate gathering or a grand celebration.</p>
                                              <p>We pride ourselves on delivering exceptional service, ensuring every moment of your wedding is seamless, memorable, and infused with modern elegance. From the smallest detail to the grandest gesture, our team is here to provide support every step of the way.</p>
                                              <p>At CocoLoco, we understand the importance of balancing style and budget. We proudly work with you to create a wedding experience that fits your financial needs, without sacrificing the quality and elegance you deserve.</p>
                                              </p>

                                              <button className="service-button" onClick={handleNavigate}>
                                                  Click Here For See More Gallery ..
                                              </button>


               </div>

           </div>
    );
};

export default Service2;
